module.exports = __webpack_public_path__ + "static/media/garlic.71ef57e4.jpg";